import React from 'react';
import { Table } from 'semantic-ui-react';

import './ResizableHeaderCellV815.css';

const ResizableHeaderCellV815 = ({
  columnKey,
  width,
  onResizeStart,
  onResetWidth,
  children,
  className = '',
  style,
  ...props
}) => (
  <Table.HeaderCell
    {...props}
    className={`resizable-header-cell-v815 ${className}`.trim()}
    style={{ ...style, width: `${width}px` }}
  >
    <span className='resizable-header-label-v815'>{children}</span>
    <span
      className='resizable-header-handle-v815'
      role='separator'
      aria-orientation='vertical'
      aria-label={`Resize ${columnKey} column`}
      onClick={(event) => event.stopPropagation()}
      onDoubleClick={(event) => {
        event.preventDefault();
        event.stopPropagation();
        onResetWidth(columnKey);
      }}
      onPointerDown={(event) => onResizeStart(event, columnKey)}
    />
  </Table.HeaderCell>
);

export default ResizableHeaderCellV815;
